import { apiInstance } from '../../api';
import { queueRoute } from './queue.route';

export class ApiApartmentQueueService {
  static async fetchQueues(residentialComplexId) {
    return apiInstance.get(`${queueRoute}/${residentialComplexId}`);
  }

  static async createQueue(name, apartmentResidentialComplexId) {
    return apiInstance.post(queueRoute, { name, apartmentResidentialComplexId });
  }

  static async changeQueue(queueId, residentialComplexId, newName) {
    return apiInstance.put(`${queueRoute}/${queueId}`, {
      name: newName,
      residentialComplexId,
    });
  }

  static async deleteQueue(queueId) {
    return apiInstance.delete(`${queueRoute}/${queueId}`);
  }
}
